import { Backdrop, Button, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Switch, Typography } from '@mui/material'
import { useFormik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import * as yup from "yup"
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid'
import City from '../../../../../components/utils/dropDown/city'
import Country from '../../../../../components/utils/dropDown/country'
import State from '../../../../../components/utils/dropDown/state'
import CustomTextField from '../../../../../components/utils/input/customTextField'
import Modal from '../../../../../components/utils/modal/modal'
import axios from 'axios'
import EditNoteIcon from '@mui/icons-material/EditNote'
import DeleteIcon from '@mui/icons-material/Delete'
import DeletePage from '../../../../../components/utils/deleteModal/deletePage'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import Loader from '../../../../../components/loader/loader'
import { Helmet } from 'react-helmet-async'
import OutletStatus from './outletStatus'
import ProductMapping from './productMapping'

const Outlets = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100]
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openDialog1, setOpenDialog1] = useState(false)
  const [openProduct, setOpenProduct] = useState(false)
  const [data, setData] = useState([])
  const [activeId, setActiveId] = useState(null)
  const [countryObj, setCountryObj] = useState(null)
  const [stateObj, setStateObj] = useState(null)
  const [cityObj, setCityObj] = useState(null);
  const [isLoader, setIsLoader] = useState(false); //loader
  const [isClosed, setIsClosed] = useState(false);
  const outletId = localStorage.getItem("outlet_id");
  const [closedStatus, setClosedStatus] = useState({}); 
  const [openResetModal, setOpenResetModal] = useState(false);
  const [outletToReset, setOutletToReset] = useState(null);
  const [selectedOutletId, setSelectedOutletId] = useState(null);
  const [outletData, setOutletData] = useState([])
  const [outletData1, setOutletData1] = useState([])
  const [outletToData, setOutletToData] = useState([]);
  const [fromOutlet, setFromOutlet] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [selectedOutletName, setSelectedOutletName] = useState('');
 
  const handleOpenResetModal = (id) => {
    setOutletToReset(id);
    setOpenResetModal(true);
  };



  const handleCloseResetModal = () => {
    setOpenResetModal(false);
    setOutletToReset(null);
  };
  const handleCloseModal = () => {
    setOpenResetModal(false); // Close the modal
  };
const validation = yup.object({
  code : yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  name:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  shortName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  address1: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  address2: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  additionalOption: yup.string(),
  country: yup.object().required('Select anyone Country'),
  state:yup.object().required('Select anyone state'),
  city:yup.object().required('Select anyone city'),
  phone: yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
  .min(10, "Minimum 10 digits required")
  .max(10, "Maximum 10 digits allowed")
  // .notRequired('This field is required!'),
  .notRequired(),
  mobile: yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
  .matches(/^\d+$/, "Only digits are allowed")
  .notRequired(),
  pincode: yup.string().matches(/^\S.*$/, "Empty space not allowed!") .matches(/^\d+$/, "Only digits are allowed")
  .required('This field is required!'),
  email: yup.string("Enter your email").email("Enter a valid email").required("This field is required!"),
  website: yup.string()
  .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!'
  )
  .required('This field is required!'),
  gstin:yup.string()
  .matches(/^([0][1-9]|[1-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]/, 'Invalid GSTIN format')
  .required('This field is required!'),
  fssai:yup.string()
  .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number format')
  .required('PAN number is required'),
  outletOption:yup.string().required('This field is required!'),
  gstApplicable:yup.string().required('This field is required!'),
  bankAccNo:yup.string().matches(/^\d{9,18}$/, 'Invalid bank account number format').required('This field is required!'),
  bankName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  accName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
  ifscCode:yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format').required('This field is required!'),
  creditLimit:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
  .matches(/^\d+$/, "Only digits are allowed")
  .notRequired('This field is required!'),
  limitation:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
  .matches(/^\d+$/, "Only digits are allowed")
  .required('This field is required!'),
  wallet_balance:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
  .matches(/^\d+$/, "Only digits are allowed")
  .required('This field is required!'),
  sales_margin:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
  .matches(/^\d+$/, "Only digits are allowed")
  .required('This field is required!'),
})
const formik = useFormik({
initialValues:{
  code:"",
  name:"",
  shortName:"",
  country : null,
  state:null,
  city : null,
  address1:"",
  address2:"",
  phone:"",
  mobile:"",
  email: "",
  website:"",
  gstin:"",
  fssai:"",
  outletOption:"",
  gstApplicable:"",
  bankAccNo:"",
  bankName:"",
  accName:"",
  ifscCode:"",
  pincode:"",
  additionalOption:"",
  creditLimit:"",
  limitation:"",
  wallet_balance:"",
  sales_margin: ""
},
validationSchema:validation,
onSubmit : isEdit ? handleUpdate : handleCreate

})
const handleSwitchChange = async (event, id) => {
  const newValue = event.target.checked;
  setClosedStatus((prev) => ({
    ...prev,
    [id]: newValue, // Update the status for the specific outlet ID
  }));

  const url = '/v1/barcode/deactivate/isclose';
  const data = {
    outlet_id: id, // Use the specific outlet ID here
    is_closed: 0, // Assuming 1 for closed, 0 for open
  };

  try {
    const response = await axios.post(url, data);
    console.log('Success:', response.data);
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
};


const columns = [
  {
    field: "sno",
    headerName: "S.no",
    minWidth: 70,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "code",
    headerName: "Code",
    minWidth: 130,
    headerAlign: "left",
    align: "left",
    sortable: false,
  },
  {
    field: "name",
    headerName: "Outlet Name",
    // flex:1,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "shortName",
    headerName: "Short Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 250,
    headerAlign: "left",
    align: "left",
    sortable: false,
  },
  {
    field: "phone",
    headerName: "Phone No.",
    minWidth: 150,
    headerAlign: "left",
    align: "left",
    sortable: false,
  },
  {
    field: "website",
    headerName: "Website",
    minWidth: 250,
    headerAlign: "left",
    align: "left",
    sortable: false,
  },
  {
    field: 'action',
    headerName: 'Action',
    // minWidth: 130,
    // minWidth: 100,
    headerAlign: "center",
    disableExport: true ,
    align: "center",
    editable: false,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <div className='flex justify-center w-full'>
        <IconButton onClick={()=>onEdit(params.row)} >
          <EditNoteIcon sx={{color:"#1972d2",fontSize:22}}/>
        </IconButton>
        <IconButton onClick={() => OnDelete(params.id)}>
          <DeleteIcon sx={{color:"red",fontSize:22}}/>
        </IconButton>
        
      </div>
    ),
  },
  {
    field: 'resetcount',
    headerName: 'Reset Count',
    minWidth: 200,
    // minWidth: 100,
    headerAlign: "center",
    disableExport: true ,
    align: "center",
    editable: false,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <div className='flex justify-center w-full'>
     <IconButton>
     {params && params.id && (
                <Button 
                variant='contained' size='small' sx={{ borderRadius: '120px',fontSize: 10 }}
                
                onClick={() => OnReset(params.id)}>
                    Reset Count
                </Button>
            )}
     {/* <Button onClick={() => OnReset(params.id)}>Reset</Button> */}
            {/* <Button sx={{ color: 'orange', fontSize: 22 }}  onClick={() => handleOpenResetModal(params.row.id)}>Reset</Button> */}
          </IconButton>
    </div>
    ),
  },
  // {
  //   field: 'assignProduct',
  //   headerName: 'Assign Product',
  //   minWidth: 130,
  //   minWidth: 100,
  //   headerAlign: "center",
  //   disableExport: true ,
  //   align: "center",
  //   editable: false,
  //   sortable: false,
  //   disableColumnMenu: true,
  //   renderCell: (params) => (
  //     <div className='flex justify-center w-full'>
  //    <IconButton>
  //    {params && params.id && (
  //               <Button 
  //               variant='contained' size='small' 
  //               sx={{
  //                 borderRadius: '120px',
  //                 fontSize: 10,
  //                 // backgroundColor: 'green', // Set button background color to green
  //                 // ':hover': {
  //                 //     backgroundColor: 'darkgreen' // Optional: Darker green on hover
  //                 // }
  //             }}
  //               onClick={() => OnAssignProduct(params.id,params.row.name)}>
  //                   Assign Product
  //               </Button>
  //           )}
  //    {/* <Button onClick={() => OnReset(params.id)}>Reset</Button> */}
  //           {/* <Button sx={{ color: 'orange', fontSize: 22 }}  onClick={() => handleOpenResetModal(params.row.id)}>Reset</Button> */}
  //         </IconButton>
  //   </div>
  //   ),
  // },
];

const rows = _.map(data, (val,idx)=>({
  id: val.id,
  sno: ++idx,
  code: val.code,
  name: val.fullname,
  email:val.email,
  shortName : val.short_name,
  countryId: val.country,
  country_name: val.country_name,
  stateId: val.state,
  state_name : val.state_name,
  city_name: val.city_name,
  cityId: val.city,
  phone: val.phone,
  mobile:val.mobile,
  website : val.website,
  add1: val.add1,
  add2: val.add2,
  add3: val.add3,
  add4: val.add4,
  gstIn : val.gstin,
  ifscCode : val.ifsccode,
  fssai : val.fssai,
  accName: val.acname,
  bankName: val.bankname,
  pincode: val.pincode,
  bankAccNo : val.bankacno,
  outletType: val.outlet_type,
  outletName : val.outlet_type_name,
  isGst : val.is_gst,
  franchise_type:val.franchise_type,
  franchise_type_name:val.franchise_type_name,
  creditLimit:val.credit_limit,
  limitation:val.limitation,
  wallet_balance:val.wallet_balance,
  sales_margin:val.sales_margin
}))

const props = {
  rows : rows,
  columns : columns,
  search : search,
  setSearch : setSearch,
  page: page,
  setPage : setPage,
  rowsPerPage : rowsPerPage,
  setRowsPerPage : setRowsPerPage,
  pageCount : pageCount,
  pageOption : pageOption
}

const onCreate = ()=>{
  setOpen(true)
  formik.resetForm()
  setIsEdit(false)
  setCountryObj(null)
  setCityObj(null)
  setStateObj(null)
  }
console.log(formik.values.outletOption)
console.log(formik.values.additionalOption)

function handleCreate(){

 const outletData = {
  code: formik.values.code,
  short_name: formik.values.shortName,
  fullname: formik.values.name,
  add1: formik.values.address1,
  add2: formik.values.address2,
  add3: "-",
  add4: "-",
  city: formik.values.city.id,
  pincode: formik.values.pincode,
  state: formik.values.state.id,
  country: formik.values.country.id,
  phone: formik.values.phone==='' ? '-' : formik.values.phone,
  mobile: formik.values.mobile==='' ? '-' : formik.values.mobile,
  email: formik.values.email,
  website: formik.values.website,
  gstin: formik.values.gstin,
  fssai: formik.values.fssai,
  outlet_type: formik.values.outletOption==='OWN' ? 1 : formik.values.outletOption==="FRANCHISE" ? 2 : 3,
  bankacno: formik.values.bankAccNo,
  bankname: formik.values.bankName,
  acname: formik.values.accName,
  ifsccode: formik.values.ifscCode,
  company_id:1,
  is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
  franchise_type :  formik.values.additionalOption === "COFO" ? 1 : 2,
  credit_limit:formik.values.creditLimit || 0,
  limitation:parseFloat(formik.values.limitation).toFixed(2),
  wallet_balance:formik.values.wallet_balance,
  sales_margin:formik.values.sales_margin
}
console.log(outletData)
 setIsLoader(true);
 axios.post(`/v1/outlet`, outletData)
 .then(res=>{
  dispatch(setSnackbar(true, 'success', 'Created Successfully'))
  getOutletData()
  setOpen(false)
  setIsLoader(false);
 })
 .catch(err=>{
  console.log(err)
  dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
  setIsLoader(false);
 })
}
function onEdit(e){
  console.log(e)
  formik.resetForm()
  formik.setFieldValue('code',e.code)
  formik.setFieldValue('name',e.name)
  formik.setFieldValue('shortName', e.shortName)
  formik.setFieldValue('address1',e.add1)
  formik.setFieldValue('address2',e.add2)
  formik.setFieldValue('address3',"-")
  formik.setFieldValue('address4',"-")
  setCountryObj(e.countryId)
  setStateObj(e.stateId)
  setCityObj(e.cityId)
  formik.setFieldValue('gstApplicable',e.isGst === true ?'Yes' : 'No')
  formik.setFieldValue('outletOption', e.outletType===1 ? 'OWN' : e.outletType===2 ? 'FRANCHISE' : 'OTHER'  )
  formik.setFieldValue('pincode',e.pincode)
  formik.setFieldValue('phone', e.phone==='-' ? '' : e.phone)
  formik.setFieldValue('mobile', e.mobile==='-' ? '' : e.mobile)
  formik.setFieldValue('email',e.email)
  formik.setFieldValue('website',e.website)
  formik.setFieldValue('gstin',e.gstIn)
  formik.setFieldValue('fssai',e.fssai)
  formik.setFieldValue('bankAccNo',e.bankAccNo)
  formik.setFieldValue('accName',e.accName)
  formik.setFieldValue('ifscCode',e.ifscCode)
  formik.setFieldValue('bankName',e.bankName) 
  formik.setFieldValue('additionalOption' , e.franchise_type === 1 ? "COFO" : "FOFO")   
  formik.setFieldValue('creditLimit' , e.creditLimit)
  formik.setFieldValue('limitation' ,e.limitation)
  formik.setFieldValue('wallet_balance' , e.wallet_balance)
  formik.setFieldValue('sales_margin' , e.sales_margin)
  
setIsEdit(true)
setOpen(true)
setActiveId(e.id)
}
function handleUpdate(){
  const outletData = {
    code: formik.values.code,
    short_name: formik.values.shortName,
    fullname: formik.values.name,
    add1: formik.values.address1,
    add2: formik.values.address2,
    add3:"-",
    add4: "-",
    city: formik.values.city.id,
    pincode: formik.values.pincode,
    state: formik.values.state.id,
    country: formik.values.country.id,
    phone: formik.values.phone==='' ? '-' : formik.values.phone,
    mobile: formik.values.mobile==='' ? '-' : formik.values.mobile,
    email: formik.values.email,
    website: formik.values.website,
    gstin: formik.values.gstin,
    fssai: formik.values.fssai,
    outlet_type: formik.values.outletOption==='OWN' ? 1 : formik.values.outletOption==="FRANCHISE" ? 2 : 3,
    bankacno: formik.values.bankAccNo,
    bankname: formik.values.bankName,
    acname: formik.values.accName,
    ifsccode: formik.values.ifscCode,
    company_id:1,
    is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
    franchise_type :  formik.values.additionalOption === "COFO" ? 1 : 2,
    credit_limit:formik.values.creditLimit,
    limitation:parseFloat(formik.values.limitation).toFixed(2),
    wallet_balance:formik.values.wallet_balance,
    sales_margin:formik.values.sales_margin,
   }
   setIsLoader(true);
   axios.put(`/v1/outlet/${activeId}`, outletData)
   .then(res=>{
    dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
    getOutletData()
    setOpen(false)
    setIsLoader(false);
   })
   .catch(err=>{
    console.log(err)
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    setIsLoader(false);
   })
}
  function OnDelete(id){
    setOpenDialog(true)
    setActiveId(id)
  }    
  function OnReset(id){
    setOpenDialog1(true)
    setActiveId(id)
    setSelectedOutletId(id);
    setClosedStatus((prev) => ({
        ...prev,
        [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
    }));
  }    
  function OnAssignProduct(id,name){
    // const selectedOutlet = outletData.find(outlet => outlet.id === id);
    // setFromOutlet(selectedOutlet || null);
    formik.resetForm();
    setSelectedOutletName(name);
    setOpenProduct(true)
    setActiveId(id)
    setSelectedOutletId(id);
   
    setClosedStatus((prev) => ({
        ...prev,
        [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
    }));

    console.log(selectedOutlet,"selectedOutlet");
    
  }    

const handleDelete = ()=>{
  setIsLoader(true);
  setOpenDialog(false)
  setActiveId(null)
  
axios.delete(`/v1/outlet/${activeId}`)
.then(res=>{
  dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
  getOutletData()
  setIsLoader(false);
  setOpen(false)
  
})
.catch(err=>{
  dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
  setIsLoader(false);
})
}
const handleOutletSelect = (id) => {
  setSelectedOutletId(id);
  setClosedStatus((prev) => ({
      ...prev,
      [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
  }));
};

const getOutletData = () =>{
  const url = `/v1/outlet/1/${rowsPerPage}/${page + 1}`
  const searchUrl = `/v1/outlet/1/${rowsPerPage}/${page + 1}/${search}`
  setIsLoader(true)
  axios.get(search === '' ? url : searchUrl)
  .then(res=>{
    setData(res.data.data)
    setPageCount(res.data.meta.pagination.total)
    setIsLoader(false)
  })
  .catch(err=>{
    console.log(err)
    setIsLoader(false)
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
  })
}
const handleMobile =(e)=>{
  formik.setFieldValue('mobile', e.target.value.replace(/\D/g, "").trim())
}
const handlePhone =(e)=>{
  formik.setFieldValue('phone', e.target.value.replace(/\D/g, "").trim())
}
const handleAcc =(e)=>{
  formik.setFieldValue('bankAccNo', e.target.value.replace(/\D/g, "").trim())
}
// useEffect(() => {
//   const fetchOutletStatus = async () => {
//     try {
//       const response = await axios.get(`/v1/barcode/status/${outletId}`);
//       const statuses = response.data;
//       const statusMap = {};
//       statuses.forEach(outlet => {
//         statusMap[outlet.id] = outlet.is_closed;
//       });
//       setClosedStatus(statusMap);
//     } catch (error) {
//       console.error('Error fetching outlet statuses:', error.response ? error.response.data : error.message);
//       // Optionally handle the case where the route is not found
//       if (error.response && error.response.status === 404) {
//         console.warn(`No data found for outlet ID: ${outletId}`);
//         setClosedStatus((prev) => ({
//           ...prev,
//           [outletId]: false // or whatever default you want
//         }));
//       }
//     }
//   };

//   fetchOutletStatus();
// }, [outletId]);

useEffect(()=>{
  getOutletData()
  
},[rowsPerPage, page, search])


  return (
    <Fragment >
      <Helmet>
        <title>Outlet Info</title>
      </Helmet>
<Typography variant='h5'>Outlet Info</Typography>
{!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
<Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}> 
<div style={{textAlign:"right"}}>
<Button variant='outlined' onClick={() => setOpen(false)}>Close</Button>
  </div>
    <Grid container spacing={2}>
      <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>1. User Details</Typography></Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomTextField id='code' value={formik.values.code} title='Code' multiple={false} placeholder='Enter Code' onchange={formik.handleChange} errorMsg={formik.touched.code && Boolean(formik.errors.code)} helperText={formik.touched.code && formik.errors.code}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='name' value={formik.values.name} title='Name' multiple={false} placeholder='Enter name' onchange={formik.handleChange} errorMsg={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name}/>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='shortName' value={formik.values.shortName} title='Short Name' multiple={false} placeholder='Enter Short Name' onchange={formik.handleChange} errorMsg={formik.touched.shortName && Boolean(formik.errors.shortName)} helperText={formik.touched.shortName && formik.errors.shortName}/>
      </Grid>
      <Grid item xs={12} >
    <Divider />
    </Grid>
      <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>2. Address Details</Typography></Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address1' value={formik.values.address1} title='Address 1' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address1 && Boolean(formik.errors.address1)} helperText={formik.touched.address1 && formik.errors.address1}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='address2' value={formik.values.address2} title='Address 2' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address2 && Boolean(formik.errors.address2)} helperText={formik.touched.address2 && formik.errors.address2}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
    <CustomTextField id='pincode' value={formik.values.pincode} title='Pincode' multiple={false} placeholder='Enter pincode' onchange={formik.handleChange} errorMsg={formik.touched.pincode && Boolean(formik.errors.pincode)} helperText={formik.touched.pincode && formik.errors.pincode}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <Country formik={formik} countryId={countryObj}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <State formik={formik} stateId={stateObj}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <City formik={formik} cityId={cityObj}/>
    </Grid>
    <Grid item xs={12} >
    <Divider />
    </Grid>
    <Grid item xs={12} >
      <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>3. Contact Details</Typography>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='phone' value={formik.values.phone} title='Phone' multiple={false} placeholder='Enter phone No' onchange={handlePhone} errorMsg={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile' multiple={false} placeholder='Enter mobile No' onchange={handleMobile} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='email' value={formik.values.email} title='Email' multiple={false} placeholder='Enter email' onchange={formik.handleChange} errorMsg={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='website' value={formik.values.website} title='Website' multiple={false} placeholder='Enter website' onchange={formik.handleChange} errorMsg={formik.touched.website && Boolean(formik.errors.website)} helperText={formik.touched.website && formik.errors.website}/>
    </Grid>
    <Grid item xs={12} >
    <Divider />
    </Grid>
    <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>4. GST Details</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='gstin' value={formik.values.gstin} title='GSTIN' multiple={false} placeholder='Enter gstin' onchange={formik.handleChange} errorMsg={formik.touched.gstin && Boolean(formik.errors.gstin)} helperText={formik.touched.gstin && formik.errors.gstin}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='fssai' value={formik.values.fssai} title='Pan Number' multiple={false} placeholder='Enter Pan Number' onchange={formik.handleChange} errorMsg={formik.touched.fssai && Boolean(formik.errors.fssai)} helperText={formik.touched.fssai && formik.errors.fssai}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='limitation' value={formik.values.limitation} title='Month wise Expense Limitations' multiple={false} placeholder='Enter Limitation' onchange={formik.handleChange} errorMsg={formik.touched.limitation && Boolean(formik.errors.limitation)} helperText={formik.touched.limitation && formik.errors.limitation}/>
    </Grid>
    <Grid item xs={12}  md={4} lg={3} >
  <Typography variant="body1" my={1}> Outlet Type</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="outletOption"
        id="outletOption"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={(event) => {
          formik.handleChange(event);
          // Reset additionalOption if the selected outletOption is not 'FRANCHISE'
          if (event.target.value !== 'FRANCHISE') {
            formik.setFieldValue('additionalOption', '');
          }
        }}
      >
        <FormControlLabel
          value="OWN"
          control={<Radio size="small" checked={formik.values.outletOption==='OWN'} />}
          label="Own"
        />
        <FormControlLabel
          value="FRANCHISE"
          control={<Radio size="small"  checked={formik.values.outletOption==='FRANCHISE'}/>}
          label="Franchise"
        />
        <FormControlLabel
          value="OTHER"
          control={<Radio size="small" checked={formik.values.outletOption==='OTHER'} />}
          label="Others"
        />
      </RadioGroup>
      
      {formik.values.outletOption === 'FRANCHISE' ? (
        <>
        <Typography variant="body1" my={1}> Franchise Type : </Typography>
          <RadioGroup
          aria-labelledby="additional-radio-group-label"
          name="additionalOption"
          id="additionalOption"
          sx={{ flexDirection: 'row', display: 'flex' }}
          onChange={formik.handleChange}
          value={formik.values.additionalOption}
        >
          <FormControlLabel
            value="COFO"
            control={<Radio size="small" checked={formik.values.additionalOption === 'COFO'}/>}
            label="Company Owned Franchise Operated"
          />
          <FormControlLabel
            value="FOFO"
            control={<Radio size="small" checked={formik.values.additionalOption === 'FOFO'}/>}
            label="Franchise Owned Franchise Operated"
          />
        </RadioGroup>
        
        </>
      
      ) : null}
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.outletOption && formik.errors.outletOption}</Typography>
    </FormControl>
  </Grid>
  {formik.values.outletOption === 'FRANCHISE' ? (
  <Grid item xs={12} md={4} lg={3}>
   
          <CustomTextField id='creditLimit' value={formik.values.creditLimit} title='Credit Limit' multiple={false} placeholder='Enter Credit Limit' onchange={formik.handleChange} errorMsg={formik.touched.creditLimit && Boolean(formik.errors.creditLimit)} helperText={formik.touched.creditLimit && formik.errors.creditLimit}/>
    
    
  </Grid>
  ): null}
  <Grid item xs={12}  md={4} lg={3}  >
  <Typography variant="body1" my={1}> Gst Applicable</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="gstApplicable"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Yes"
          control={<Radio size="small" checked={formik.values.gstApplicable==='Yes'} />}
          label="Yes"
        />
        <FormControlLabel
          value="No"
          control={<Radio size="small" checked={formik.values.gstApplicable==='No'}/>}
          label="No"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.gstApplicable && formik.errors.gstApplicable}</Typography>

    </FormControl>
  </Grid>
  <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='wallet_balance' value={formik.values.wallet_balance} title='Wallet Balance' multiple={false} placeholder='Enter wallet balance' onchange={formik.handleChange} errorMsg={formik.touched.wallet_balance && Boolean(formik.errors.wallet_balance)} helperText={formik.touched.wallet_balance && formik.errors.wallet_balance}/>
    </Grid>
  <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='sales_margin' value={formik.values.sales_margin} title='Sales Margin' multiple={false} placeholder='Enter Sales Margin' onchange={formik.handleChange} errorMsg={formik.touched.sales_margin && Boolean(formik.errors.sales_margin)} helperText={formik.touched.sales_margin && formik.errors.sales_margin}/>
    </Grid>
  <Grid item xs={12} >
        <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>5. Bank Details</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='bankAccNo' value={formik.values.bankAccNo} title='Bank Acc No' multiple={false} placeholder='Enter Bank Acc No' onchange={handleAcc} errorMsg={formik.touched.bankAccNo && Boolean(formik.errors.bankAccNo)} helperText={formik.touched.bankAccNo && formik.errors.bankAccNo}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='bankName' value={formik.values.bankName} title='Bank Name' multiple={false} placeholder='Enter Bank Name' onchange={formik.handleChange} errorMsg={formik.touched.bankName && Boolean(formik.errors.bankName)} helperText={formik.touched.bankName && formik.errors.bankName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='accName' value={formik.values.accName} title='Account Holder Name' multiple={false} placeholder='Enter Account Holder Name' onchange={formik.handleChange} errorMsg={formik.touched.accName && Boolean(formik.errors.accName)} helperText={formik.touched.accName && formik.errors.accName}/>
    </Grid>
    <Grid item xs={12} md={4} lg={3}>
      <CustomTextField id='ifscCode' value={formik.values.ifscCode} title='IFSC Code' multiple={false} placeholder='Enter IFSC Code' onchange={formik.handleChange} errorMsg={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)} helperText={formik.touched.ifscCode && formik.errors.ifscCode}/>
    </Grid>
    </Grid>
</Modal>
}
<Grid className='bg-white rounded-md p-2 my-3'>
<CustomDataGrid props={props}/>
</Grid>
<Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
<Backdrop open={openDialog1} sx={{zIndex:1250}}>
  <OutletStatus setOpen={setOpen} onCancel={setOpenDialog1} onSubmit={OnReset} setClosedStatus={setClosedStatus}
  outletId={selectedOutletId}
  closedStatus={closedStatus} // This should be an object with outlet IDs as keys

  />
 
</Backdrop>
<Backdrop open={openProduct} sx={{zIndex:1050}}>
  {/* <ProductMapping onCancel={setOpenProduct}   onSubmit={OnAssignProduct}

  /> */}

    <ProductMapping 
    onCancel={setOpenProduct}   onSubmit={OnAssignProduct} 
    fromOutlet={selectedOutlet} outletId={selectedOutletId} selectedOutletName={selectedOutletName}setSelectedOutletName={setSelectedOutletName}
    />

</Backdrop>
{/* <Modal open={openResetModal} onClose={handleCloseModal}>
        <div className="modal-content">
          <Typography variant="h5">Reset Confirmation</Typography>
          <Typography>Are you sure you want to reset?</Typography>
          <Button onClick={handleCloseModal}>Cancel</Button>

        </div>
      </Modal> */}
{/* <Loader isLoader={isLoader}/> */}
   </Fragment>
  )
}

export default Outlets